<template>
    <sui-segment :loading="isLoading">
        <div class="header-container">
            <div>
                <h1 is="sui-header">Plannings ateliers de {{ customer.name }} (#{{customer.id}})</h1>
            </div>
            <div v-if="workshopSchedules.length > 0">
                <router-link
                    class="ui violet button right floated"
                    :to="{ name: 'CustomerWorkshopScheduleForm' }"><sui-icon name="plus"/>{{ $t('workshopSchedule.list.new') }}
                </router-link>
            </div>
        </div>

         <sui-table class="compact" celled striped selectable>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>ID</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('common.name') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('workshopSchedule.list.type') }}</sui-table-header-cell>
                    <sui-table-header-cell :width="2">{{ $t('common.actions') }}</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>

           <sui-table-body v-if="workshopSchedules.length === 0">
                <sui-table-row>
                    <sui-table-cell colspan="4" text-align="center">
                        <router-link
                            class="ui violet button fluid"
                            :to="{ name: 'CustomerWorkshopScheduleForm' }">
                            <sui-icon name="plus"/>{{ $t('workshopSchedule.list.new') }}
                        </router-link>
                    </sui-table-cell>
                </sui-table-row>
           </sui-table-body>

            <sui-table-body v-for="workshopSchedule in workshopSchedules" :key="workshopSchedule.id">
                <sui-table-row>
                    <sui-table-cell>
                        {{ workshopSchedule.id }}
                    </sui-table-cell>

                    <sui-table-cell text-align="center">
                        {{ workshopSchedule.name }}
                    </sui-table-cell>

                    <sui-table-cell text-align="center">
                        {{ workshopSchedule.type }}
                    </sui-table-cell>

                    <sui-table-cell text-align="center">
                        <router-link
                            class="ui tiny button"
                            :to="{
                                name: 'CustomerWorkshopScheduleForm',
                                params: {
                                    customer_id: customer.id,
                                    workshop_schedule_id: workshopSchedule.id
                                }
                            }">
                            {{ $t('workshopSchedule.list.edit') }}
                        </router-link>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>

         </sui-table>

    </sui-segment>
</template>

<script>
import { api } from '@/api';
import store from '@/store';

export default {
    name: 'CustomerWorkshopScheduleList',
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    data() {
        return {
            isLoading: false,
            customer: {
                id: null,
                name: null,
            },
            workshopSchedules: [],
        }
    },
    async created() {
        this.isLoading = true;
        
        await this.getWorkshopScheduleList();
        store.commit('setAppTitle', `${this.$t('workshopSchedule.form.title')} - ${this.customer.name}`);
        
        this.isLoading = false;
    },
    methods: {
        async getWorkshopScheduleList() {
            const response = await api.workshopSchedules.fetch(this.$route.params.customer_id);
            this.customer = response.customer;
            this.workshopSchedules = response.workshop_schedules;
        }
    }   
}
</script>